module.exports = __webpack_public_path__ + "assets/img/OWPG.2142a29b.png";